module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"candidateNotPassed":"Кандидат пока не прошёл","onlineInterview":"онлайн-интервью","sendInvitation":"Отправить приглашение на почту"}}')
  delete Component.options._Ctor
}
